import { useQuery } from "@tanstack/react-query";
import { listAgents } from "./agentsApi";

export const useAgents = () => {
  const { data, isLoading } = useQuery({
    queryKey: ["agents"],
    queryFn: ({ signal }) => listAgents(signal),
  });

  return {
    agents: data ?? [],
    isLoading,
  };
};
